import { collection, doc, getDocs, setDoc } from 'firebase/firestore';
import { Material } from '../sp-types/materialType';
import { db } from './firebase';

const MATERIALS_COLLECTION_NAME = 'materials';
const DB = db;

export async function createMaterialInDb(data: Material) {
  try {
    const docRef = doc(collection(DB, MATERIALS_COLLECTION_NAME), data.id);
    await setDoc(docRef, data);
    console.log('Document written with ID: ', docRef.id);
  } catch (err) {
    console.log('error found!', err);
  }
}

export async function updateMaterialInDb(data: Material) {
  try {
    const docRef = doc(collection(DB, MATERIALS_COLLECTION_NAME), data.id);
    await setDoc(docRef, data);
    console.log('Document updated with ID: ', docRef.id);
  } catch (err) {
    console.log(`error while updating`, err);
  }
}

export async function getAllMaterials(): Promise<Material[] | null> {
  const materialsRef = collection(DB, MATERIALS_COLLECTION_NAME); // Ensure FUTURE_ORDER_LOCATION is a string
  try {
    const querySnapshot = await getDocs(materialsRef);

    if (!querySnapshot.empty) {
      const materials = querySnapshot.docs.map((doc) => doc.data() as Material);
      return materials;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error getting documents:', error);
    return null;
  }
}
